/* eslint-disable no-console */
import axios from 'axios'
import { IBook } from 'models/book'
import { paramsGet } from 'models/common'
import { bindParams } from 'utilities/helpers'
import { API_BASE_URL, API_BOOKMARK, API_GET_MAGAGINE, API_GET_MAGAGINE_DETAIL, API_GET_MAGAZINE_PURCHASE, API_GET_URL_MAGAZINE } from '../configs/api'
import networkAdapter from '../utilities/networkAdapter'

export const apiGetMagazineDigital = (params: paramsGet) => {
  return networkAdapter.get(API_GET_MAGAGINE, params)
}

export const getAllMagazinePurchase = (params: paramsGet) => {
  try {
    return networkAdapter.get(API_GET_MAGAZINE_PURCHASE, params)
  } catch (error) {
    console.log('error getAllMagazinePurchase', error)
  }
}

export const getMagazineDetail = async (id: string, appId: string): Promise<IBook> => {
  const magazine = await networkAdapter.get(
    bindParams(API_GET_MAGAGINE_DETAIL, {
      id
    }),
    {
      app_id: appId
    }
  )
  return magazine.data
}

export const getImageBookMark = async (images: string[]) => {
  const dataImage = await networkAdapter.post(API_BOOKMARK, {
    images
  })
  return dataImage.data
}

export const removeImageBookMark = async (urls: string[]) => {
  const dataImage = await networkAdapter.delete(API_BOOKMARK, {
    urls
  })
  return dataImage
}

export interface IGetURLMagazine {
  is_preview: number
  app_id?: string
  device_token?: string
  token: string,
  is_purchased?: string
}

export const getURLMagazineApi = async (id: string, params: IGetURLMagazine) => {
  const getDataApi = await axios.get(
    bindParams(`${API_BASE_URL}/api/v1${API_GET_URL_MAGAZINE}`, {
      magazine_id: id
    }),
    {
      params: {
        is_preview: params.is_preview,
        app_id: params.app_id,
        device_token: params.device_token,
        is_purchased: params.is_purchased
      },
      headers: {
        Authorization: 'Bearer ' + params.token
      }
    }
  )

  return getDataApi.data
}
